import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HeatmapActions } from './heatmap.actions';
import { HeatmapService } from '../../service/heatmap.service';
import { mergeMap, map, catchError, of } from 'rxjs';

@Injectable()
export class HeatmapEffects {

  loadHeatmpaUnificata$ = createEffect(
    (rs: HeatmapService = inject(HeatmapService)) => {
      return this.actions$.pipe(

        ofType(HeatmapActions.loadHeatmapUnificata),
        mergeMap((parameters) =>
          rs.getHeatmapUnificata(parameters.legalEntityIds, parameters.campaignId, parameters.organizationalUnit, parameters.businessUnit).pipe(
            map((heatmap) => {
              return HeatmapActions.loadHeatmapUnificataSuccess({
                heatmap: heatmap
              });
            }),
            catchError((error) => of(HeatmapActions.loadHeatmapUnificataFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  loadHeatmpas$ = createEffect(
    (rs: HeatmapService = inject(HeatmapService)) => {
      return this.actions$.pipe(

        ofType(HeatmapActions.loadHeatmaps),
        mergeMap((parameters) =>
          rs.getHeatmap(parameters.legalEntityIds, parameters.campaignId, parameters.organizationalUnit, parameters.businessUnit).pipe(
            map((heatmap) => {
              return HeatmapActions.loadHeatmapsSuccess({
                heatmap: heatmap
              });
            }),
            catchError((error) => of(HeatmapActions.loadHeatmapsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  loadHeatmpaRisk$ = createEffect(
    (rs: HeatmapService = inject(HeatmapService)) => {
      return this.actions$.pipe(

        ofType(HeatmapActions.loadHeatmapRisk),
        mergeMap((parameters) =>
          rs.getHeatmapRisk(parameters.legalEntityIds, parameters.campaignId, parameters.organizationalUnit, parameters.businessUnit).pipe(
            map((heatmap) => {
              return HeatmapActions.loadHeatmapRiskSuccess({
                heatmap: heatmap
              });
            }),
            catchError((error) => of(HeatmapActions.loadHeatmapRiskFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );


  exportHeatmaps$ = createEffect(
    (as: HeatmapService = inject(HeatmapService)) => {
      return this.actions$.pipe(
        ofType(HeatmapActions.downloadHeatmaps),
        mergeMap(({ campaignId, legalEntityIds, organizationalUnit, businessUnit, timeZone }) =>
          as.downaloadHeatmaps(campaignId, legalEntityIds, organizationalUnit, businessUnit, timeZone
          ).pipe(
            map((file) => {
              this.downloadFile(
                file!.data![0]!.content,
                file!.data![0]!.filename
              );
              return HeatmapActions.downloadHeatmapsSuccess({
                heatmap: file
              });
            }),
            catchError((error) => of(HeatmapActions.downloadHeatmapsFailure({ error })))
          )
        )
      )
    }
  )

  async downloadFile(response: string, fileName: string | undefined) {
    const typeFormat = {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    };
    const link = window.document.createElement("a");
    const blob = this.base64ToBlob(response, typeFormat.type); // Cambia il tipo MIME
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName ?? "fileExport";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  }

  private base64ToBlob(base64: string, mimeType: string): Blob {
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mimeType });
  }

  constructor(private actions$: Actions) { }
}
